import { Expression } from "./abstract.expression";

export class SearchExpression extends Expression 
{
    constructor(private readonly value: string) 
    {
        super();
    }

    toQuery(): string 
    {
        return `$search=${this.value}`;
    }
}
